import getMediaURL from 'utils/getMediaURL'

export default function setThumbnail({ props, state }) {
  const { id, media, relativeOutputPath } = props.payload
  const mediaInView = state.get(`media.files.${id}`)

  const uploads = state.get('media.uploading')
  Object.keys(uploads).forEach(key => {
    const file = uploads[key]
    if (`${file.fileId}` === `${id}`) {
      state.set(
        `media.uploading.${key}.thumbnail`,
        getMediaURL(`${relativeOutputPath}/${media}`)
      )
    }
  })

  if (mediaInView) {
    state.set(
      `media.files.${id}.thumbnail`,
      getMediaURL(`${relativeOutputPath}/${media}`)
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Socket/actions/setThumbnail.js